import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React from 'react';
import { ComponentMode } from '../../../types/AppTypes';
import { TextComponent } from './TextComponent';
const debug = process.env.REACT_APP_DEBUG && false;
//const useStyles: ( x: any ) => MapLike<string>  = makeStyles((theme: Theme) => (styles(theme)));
const initialEntry = { k: 'no-op', v: 'Select value' };
export const EnumComponent = (props) => {
    const { matchedPrimary, viewKeyDefinition, mode, updateKV } = props;
    debug && console.log('EnumComponent props', props);
    const classes = {};
    let element = (_jsx(Container, { children: _jsx("div", {}) }));
    const [labelWidth, setLabelWidth] = React.useState('');
    const label = React.useRef(null);
    React.useEffect(() => {
        setLabelWidth(`${(label.current?.offsetWidth ?? 0) + 24}px`); // 24 for caret icon
    });
    if (viewKeyDefinition.enumKV) {
        if (mode === ComponentMode.EDIT && viewKeyDefinition.editable !== false) {
            debug && console.log('enter here', matchedPrimary, viewKeyDefinition.enumKV, ...Object.entries(viewKeyDefinition.enumKV));
            const accessKey = `${matchedPrimary.sk}:${viewKeyDefinition.key}`;
            element = (_jsxs(FormControl, { className: classes.editFormControlFullWidth, style: { minWidth: labelWidth }, size: "small", children: [_jsx(InputLabel, { id: accessKey, ref: label, style: { minWidth: 'max-content' }, children: viewKeyDefinition.label }), _jsx(Select, { labelId: `${accessKey}_label`, label: viewKeyDefinition.label, id: `${accessKey}_select`, value: matchedPrimary[viewKeyDefinition.key] ?? initialEntry.k, onChange: (event) => {
                            const pseudoEvent = { currentTarget: { type: 'object', value: event.target.value } };
                            if (event.target.value !== initialEntry.k) {
                                updateKV(pseudoEvent, viewKeyDefinition.key);
                                if (viewKeyDefinition.stateFn) {
                                    viewKeyDefinition.stateFn(event);
                                }
                            }
                        }, children: [
                            _jsx(MenuItem, { value: initialEntry.k, children: initialEntry.v }, `item_${initialEntry.k}`),
                            ...Object.entries(viewKeyDefinition.enumKV).map(([k, v], i) => {
                                return (_jsx(MenuItem, { value: v, children: k }, `item_${i}`));
                            }),
                        ] })] }));
        }
        else if (mode === ComponentMode.VIEW || mode === ComponentMode.READONLY) {
            const enumEntry = Object.entries(viewKeyDefinition.enumKV).find(([k, v]) => v === matchedPrimary[viewKeyDefinition.key] || v === matchedPrimary[viewKeyDefinition.key]?.sk);
            return _jsxs("div", { children: [enumEntry && enumEntry[0], " "] });
        }
        else if (viewKeyDefinition.editable === false) {
            const enumEntry = Object.entries(viewKeyDefinition.enumKV).find(([k, v]) => v === matchedPrimary[viewKeyDefinition.key] || v === matchedPrimary[viewKeyDefinition.key]?.sk);
            const value = enumEntry && enumEntry[0];
            return _jsx(TextComponent, { ...props, matchedPrimary: { ...matchedPrimary, [viewKeyDefinition.key]: value } });
        }
    }
    return element;
};
